import { useEffect } from 'react';
import { useParams, Outlet, Navigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const VALID_LANGS = ['ir', 'en'];

const LanguageLayout = () => {
  const { lang } = useParams<{ lang: string }>();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    if (lang === 'en') {
      setLanguage('en');
    } else {
      setLanguage('fa');
    }
  }, [lang, setLanguage]);

  if (!lang || !VALID_LANGS.includes(lang)) {
    return <Navigate to="/ir" replace />;
  }

  return <Outlet />;
};

export default LanguageLayout;
